import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import { APP_URLS, getAppUrl } from 'utils/app-urls';

import { Icon } from '@asgard/ui-library';
import { faCalendar } from '@fortawesome/pro-light-svg-icons';
import { CategoryBadge } from './CategoryBadge';
import * as S from './BlogSpotlightCard.styled';
import { WP_REST_API_Post, WP_REST_API_Tags } from 'wp-types';
import { useMemo } from 'react';
import { toTitleCase } from 'utils/localize.utils';

export type TeamCardProps = {
  post: WP_REST_API_Post;
  url: string;
  title: string;
  thumb?: string;
  date: string;
  excerpt?: string;
  allTags?: WP_REST_API_Tags;
};

const BlogSpotlightCard: React.FC<TeamCardProps> = ({
  post,
  url,
  title,
  thumb,
  date,
  excerpt = '',
  allTags = []
}) => {
  const { locale } = useRouter();
  const postTagNames: string[] = useMemo(() => {
    if (!Array.isArray(post.tags)) return [];
    return post.tags
      .map((tagId) => allTags.find((tag) => tag.id === tagId)?.name)
      .filter((name): name is string => Boolean(name))
      .map((name) => toTitleCase(name))
      .sort((a, b) => a.localeCompare(b));
  }, [post.tags, allTags]);

  return (
    <Link href={`${getAppUrl(APP_URLS.blog, locale)}/${url}`} passHref>
      <S.StyledCard>
        <svg width="0" height="0">
          <defs>
            <clipPath id="blogThumbClip" clipPathUnits="objectBoundingBox">
              <path d="..." />
            </clipPath>
          </defs>
        </svg>
        <S.StyledThumb>{thumb && <img src={thumb} alt="" />}</S.StyledThumb>

        <S.StyledContent>
          <S.StyledDate>
            <Icon icon={faCalendar} />
            {new Date(date).toLocaleDateString(locale, {
              year: 'numeric',
              month: 'numeric',
              day: 'numeric'
            })}
          </S.StyledDate>
          <S.StyledTitle>{title}</S.StyledTitle>
          <S.StyledExcerpt>
            <div
              dangerouslySetInnerHTML={{
                __html: excerpt
              }}
            ></div>
          </S.StyledExcerpt>
          <S.StyledTagsFix>
            <CategoryBadge tagList={postTagNames} />
          </S.StyledTagsFix>
        </S.StyledContent>
      </S.StyledCard>
    </Link>
  );
};

export default BlogSpotlightCard;
